import { render, staticRenderFns } from "./CompanyLeft.vue?vue&type=template&id=975776e2&scoped=true&"
import script from "./CompanyLeft.vue?vue&type=script&lang=js&"
export * from "./CompanyLeft.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLeft.vue?vue&type=style&index=0&id=975776e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975776e2",
  null
  
)

export default component.exports